import React from 'react';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import NumberFormatTextField from '../misc/NumberFormatTextField';
import FloatFormatTextField from './FloatFormatTextField';
import { InputAdornment } from '@material-ui/core';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

function getFieldComponent(type) {
  switch (type) {
    case 'num':
      return NumberFormatTextField;
    case 'float':
      return FloatFormatTextField;
    default:
      return TextField;
  }
}

export default function FormikField(props) {
  // Pass in field: {value: "name", label:"Account Nickname", icon?: "money"}
  const { field, width = 300, disabled = false } = props;
  const fieldComponent = getFieldComponent(field.type);

  return (
    <Field
      component={fieldComponent}
      name={field.value}
      label={field.label}
      variant="outlined"
      disabled={disabled}
      style={{ width: width }}
      InputProps={
        field.icon === 'money'
          ? {
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoneyIcon color="primary" />
                </InputAdornment>
              ),
            }
          : {}
      }
    />
  );
}
